/** A markdown docs page, one component per route so each fetches its own content. */
import type { Resource } from '@crown/framework/data';
import type { Instruction } from '@crown/framework/ir';
import { type DocPageData, docResource } from './doc-model';
import template from './doc-page.tsrx';

const DocPageView: (props: { doc: Resource<DocPageData> }) => Instruction =
  template;

export function docPage(routePath: string): () => Instruction {
  return () => DocPageView({ doc: docResource(routePath) });
}
